import { TERMINE_UPDATE_TERMINKALENDER } from '@/domain/termine/hooks/graphql/mutation';
import { toGraphQLMarkierung } from '@/domain/termine/shared/types';
import { UpdateKalenderFormValues } from '@/domain/termine/shared/types/UpdateTerminKalenderInput';
import {
  UpdateTerminKalenderMutation,
  UpdateTerminKalenderMutationVariables,
} from '@/gql/graphql';
import { useMutation } from '@apollo/client/react';

export function useUpdateTerminKalender() {
  const [mutate, { data, error, loading }] = useMutation<
    UpdateTerminKalenderMutation,
    UpdateTerminKalenderMutationVariables
  >(TERMINE_UPDATE_TERMINKALENDER, {
    refetchQueries: [
      'GetTagesDaten',
      'GetTermineKalenderByStandortIdAndZeitraum',
    ],
    fetchPolicy: 'no-cache',
  });

  // oxlint-disable-next-line complexity
  const updateTerminKalender = async (props: UpdateKalenderFormValues) => {
    try {
      const result = await mutate({
        variables: {
          name: props.name,
          markierung: toGraphQLMarkierung(props.markierung),
          idTerminKalender: props.idTerminkalender,
        },
      });
      if (result.data?.termine_terminkalenderUpdate.error) {
        throw new Error(
          result.data?.termine_terminkalenderUpdate.error.message,
        );
      }
      return result.data?.termine_terminkalenderUpdate;
    } catch (error) {
      throw error instanceof Error ? error : new Error(String(error));
    }
  };
  return {
    updateTerminKalender,
    response: data?.termine_terminkalenderUpdate,
    loading,
    error,
  };
}
